module.exports = __webpack_public_path__ + "static/launch-c7db9b68a351fc03e54c28805a1b991a.jpg";